var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 132,
    viewBox: "0 0 107 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5085 29.8347H54.3742V30.9704H55.5085V29.8347Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7482 28.7133H56.6138H55.4957V29.8327H56.6138H57.7482H58.8664V28.7133H57.7482Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0074 29.8347H58.873V30.9704H60.0074H61.1417V29.8347H60.0074Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2599 30.9626H61.1418V32.0821H62.2599H63.3943H64.5124V30.9626H63.3943H62.2599Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5062 29.8347V30.9704H65.6406H66.7588V29.8347H65.6406H64.5062Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.775 27.5724H65.6406V28.7081H66.775V27.5724Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6406 25.323H64.5062V26.4587H65.6406V25.323Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3976 23.0671H62.2632V24.2028H63.3976V23.0671Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2762 27.5724H61.1418V28.7081H62.2762V27.5724Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0074 26.4574H58.873V27.5931H60.0074V26.4574Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.532 28.7133H63.3976V29.8489H64.532V28.7133Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0309 28.7133H67.8965V29.8489H69.0309V28.7133Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2867 28.7133H70.1523V29.8489H71.2867V28.7133Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5425 28.7133H72.4082V29.8489H73.5425V28.7133Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2867 24.2015H70.1523V25.3372H71.2867V24.2015Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1523 25.323H69.0179V26.4587H70.1523V25.323Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0309 26.4574H67.8965V27.5931H69.0309V26.4574Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0309 32.0906H67.8965V33.2263H69.0309V32.0906Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1523 33.225H69.0179V34.3607H70.1523V33.225Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2867 34.34H70.1523V35.4757H71.2867V34.34Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.775 34.34H65.6406V35.4757H66.775V34.34Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.775 36.6152H65.6406V37.7509H66.775V36.6152Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.775 32.0906H65.6406V33.2263H66.775V32.0906Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.532 33.225H63.3976V34.3607H64.532V33.225Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3976 34.34H62.2632V35.4757H63.3976V34.34Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2762 35.4808H61.1418V36.6165H62.2762V35.4808Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2493 32.0852V34.3403H50.9967V35.476H49.8624V36.6117H48.728V37.7474H47.5936V38.8831H46.4593V40.0188H45.3249V41.1545H44.1906V47.92H45.3249V49.0557H46.4593V51.3108H48.7118V52.4465H49.8462V53.5822H56.6037V52.4465H58.8562V51.3108H59.9906V49.0557H61.1249V47.92H62.2593V41.1545H61.1249V38.8993H59.9906V37.7636H58.8562V36.628H56.6037V34.3728H54.3512V30.9819H53.2168V32.1176L53.2493 32.0852ZM47.6099 45.6162V43.361H48.7442V45.6162H47.6099ZM49.8624 47.8713H48.728V46.7356H49.8624V47.8713ZM49.8624 42.2253H48.728V41.0896H49.8624V42.2253ZM52.1149 48.9908H50.9805V47.8551H52.1149V48.9908Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2771 111.684H5.06604V131.997H101.405V111.684H91.2609H91.2771ZM96.3493 121.841V126.919H10.1382V116.763H96.3493V121.841Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.411 10.1578V15.236V20.3142V25.3923V30.4543V35.5325V40.6106V45.6888V50.767V55.8451V60.9233V66.0015V71.0797V76.1578V81.236V86.3142V91.3761V96.4543V101.532V106.611V111.689H106.483V106.611V101.532V96.4543V91.3761V86.3142V81.236V76.1578V71.0797V66.0015V60.9233V55.8451V50.767V45.6888V40.6106V35.5325V30.4543V25.3923V20.3142V15.236V10.1578H101.411Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 5.07886H96.3574V10.157H101.43V5.07886Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2893 5.07817H25.3614H30.4336H35.5058H40.5781H45.634H50.7062H55.7784H60.8506H65.9228H70.995H76.0672H81.1394H86.2116H91.2838H96.356V0H91.2838H86.2116H81.1394H76.0672H70.995H65.9228H60.8506H55.7784H50.7062H45.634H40.5781H35.5058H30.4336H25.3614H20.2893H15.2171H10.1449V5.07817H15.2171H20.2893Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1382 5.07886H5.06604V10.157H10.1382V5.07886Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0722 101.532V96.4543V91.3761V86.3142V81.236V76.1578V71.0797V66.0015V60.9233V55.8451V50.767V45.6888V40.6106V35.5325V30.4543V25.3923V20.3142V15.236V10.1578H0V15.236V20.3142V25.3923V30.4543V35.5325V40.6106V45.6888V50.767V55.8451V60.9233V66.0015V71.0797V76.1578V81.236V86.3142V91.3761V96.4543V101.532V106.611V111.689H5.0722V106.611V101.532Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 91.3752V96.4534H20.2831H25.3553V91.3752H20.2831H15.2109Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1392 91.3752H76.067H70.9948H65.9227V96.4534H70.9948H76.067H81.1392H86.2114H91.2836V91.3752H86.2114H81.1392Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2125 20.3149V25.393V30.455V35.5332V40.6113V45.6895V50.7677V55.8458V60.924V66.0022H91.2847V60.924V55.8458V50.7677V45.6895V40.6113V35.5332V30.455V25.393V20.3149V15.2367H86.2125V20.3149Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4342 15.236H35.5064H40.5786H45.6346H50.7068H55.779H60.8512H65.9234H70.9955H76.0677H81.1399H86.2121V10.1578H81.1399H76.0677H70.9955H65.9234H60.8512H55.779H50.7068H45.6346H40.5786H35.5064H30.4342H25.362H20.2899V15.236H25.362H30.4342Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2831 55.8458V50.7677V45.6895V40.6113V35.5332V30.455V25.393V20.3149V15.2367H15.2109V20.3149V25.393V30.455V35.5332V40.6113V45.6895V50.7677V55.8458V60.924V66.0022H20.2831V60.924V55.8458Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0677 66H70.9955H65.9234H60.8512H55.779H50.7068H45.6346H40.5786H35.5064H30.4342H25.362H20.2899V71.0782H25.362H30.4342H35.5064H40.5786H45.6346H50.7068H55.779H60.8512H65.9234H70.9955H76.0677H81.1399H86.2121V66H81.1399H76.0677Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.35094f82.svg";
export { ForwardRef as ReactComponent };